//const baseUrl = "http://15.206.179.59:3201/";
// const baseUrl = "http://3.6.39.70:3200/";
const baseUrl = "https://adminapi.valianttinfo.com/"; 
const baseUrl1 = "https://cv.valianttinfo.com/"
//const baseUrl1 = "http://15.206.179.59:3201/"
// const baseUrl = "http://3.6.39.70:3200/";
// const baseUrl = "http://127.0.0.1:7272/";
// const baseUrl1 = "http://3.6.39.70:3202/"
export { baseUrl,baseUrl1 };
